<div [loadingOverlay]="isLoading" class="card mx-5">
	<div class="card-header">
		Customer Campaign Setup
	</div>
	<div class="card-body">
		<app-tab-panel [displayMode]="TabPanelDisplayMode.horizontalPill">
			<app-tab title="Add Company">
				<div *tabContent>
					<div class="row">
						<div class="col-md-12">
							<div class="mt-2 mb-4 small text-muted">
								Enter the details for the company we will be doing SEO work for.
								Do not enter the agency's information, this should be the actual client's business.
							</div>
							<form role="form" [formGroup]="customerForm">
								<div class="row">
									<div class="form-group col-md-6">
										<label class="control-label">Company Name*</label>
										<input type="text" class="form-control" formControlName="companyName" lpValidationMsg/>
									</div>
									<div class="form-group col-md-6">
										<label class="control-label">Country*</label>
										<ng-select [items]="countries" [clearable]="true" placeholder="Choose..." bindLabel="Name" bindValue="CountryId"
											formControlName="countryId" [virtualScroll]="true" lpValidationMsg></ng-select>
									</div>
									<div class="form-group col-md-6">
										<label class="control-label">Website*</label>
										<input type="text" class="form-control" formControlName="website" lpValidationMsg/>
									</div>
									<div class="form-group col-md-6">
										<label class="control-label">Language*</label>
										<ng-select [items]="languages" [clearable]="true" placeholder="Choose..." bindLabel="Name" bindValue="LanguageId"
											formControlName="languageId" [virtualScroll]="true" lpValidationMsg></ng-select>
									</div>
									<ng-container *ngIf="partner?.PartnerId === 1">
										<div class="form-group col-md-6">
											<label class="control-label">Lead Source</label>
											<ng-select [items]="leadSources" [clearable]="true" placeholder="Choose..." bindLabel="Name"
												bindValue="LeadSourceId" formControlName="leadSourceId" [virtualScroll]="true"
												[addTag]="addLeadSource.bind(this)" addTagText="Add Lead Source"></ng-select>
										</div>
									</ng-container>
								</div>
							</form>
							<div class="d-flex align-items-center">
								<ng-container *ngIf="partner?.PartnerId !== 1">
									<a class="link cursor-pointer" (click)="showMerchantFields = !showMerchantFields">
										Advanced Merchant Fields
									</a>
								</ng-container>
								<button tabNext class="btn btn-primary ms-auto" [disabled]="!customerForm.valid">
									Next
									<i class="fa fa-arrow-right ms-1"></i>
								</button>
							</div>
						</div>
					</div>
					<ng-container *ngIf="showMerchantFields && merchantFieldLabelMap">
						<form [formGroup]="merchantFieldsForm">
							<hr/>
							<div class="row">
								<div class="col-md-4">
									<div class="form-group">
										<label class="control-label">{{merchantFieldLabelMap.IdLabel.Value}}</label>
										<input type="text" class="form-control" formControlName="merchantId"/>
									</div>
									<div class="form-group">
										<label class="control-label">{{merchantFieldLabelMap.SourceLabel.Value}}</label>
										<input type="text" class="form-control" formControlName="merchantSource"/>
									</div>
									<div class="form-group">
										<label class="control-label">{{merchantFieldLabelMap.ProposalIdLabel.Value}}</label>
										<input type="text" class="form-control" formControlName="merchantProposalId"/>
									</div>
									<div class="form-group">
										<label class="control-label">{{merchantFieldLabelMap.ConsultantLabel.Value}}</label>
										<input type="text" class="form-control" formControlName="merchantConsultant"/>
									</div>
									<div class="form-group">
										<label class="control-label">{{merchantFieldLabelMap.ConsultantContactLabel.Value}}</label>
										<input type="text" class="form-control" formControlName="merchantConsultantContact"/>
									</div>
									<div class="form-group">
										<label class="control-label">{{merchantFieldLabelMap.CustomerValueLabel.Value}}</label>
										<input type="text" class="form-control" formControlName="merchantCustomerValue"/>
									</div>
									<div class="form-group">
										<label class="control-label">{{merchantFieldLabelMap.ContractEndDateLabel.Value}}</label>
										<input type="text" class="form-control" formControlName="merchantContractEndDate"/>
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label class="control-label">{{merchantFieldLabelMap.CategoryLabel.Value}}</label>
										<input type="text" class="form-control" formControlName="merchantCategory"/>
									</div>
									<div class="form-group">
										<label class="control-label">{{merchantFieldLabelMap.CategoryIdLabel.Value}}</label>
										<input type="text" class="form-control" formControlName="merchantCategoryId"/>
									</div>
									<div class="form-group">
										<label class="control-label">{{merchantFieldLabelMap.SubCategoryLabel.Value}}</label>
										<input type="text" class="form-control" formControlName="merchantSubCategory"/>
									</div>
									<div class="form-group">
										<label class="control-label">{{merchantFieldLabelMap.SubCategoryIdLabel.Value}}</label>
										<input type="text" class="form-control" formControlName="merchantSubCategoryId"/>
									</div>
									<div class="form-group">
										<label class="control-label">{{merchantFieldLabelMap.UdacLabel.Value}}</label>
										<input type="text" class="form-control" formControlName="merchantUdac"/>
									</div>
									<div class="form-group">
										<label class="control-label">{{merchantFieldLabelMap.CampaignManagerLabel.Value}}</label>
										<input type="text" class="form-control" formControlName="merchantCampaignManager"/>
									</div>
									<div class="form-group">
										<label class="control-label">{{merchantFieldLabelMap.CampaignManagerContactLabel.Value}}</label>
										<input type="text" class="form-control" formControlName="merchantCampaignManagerContact"/>
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label class="control-label">{{merchantFieldLabelMap.ProductCodeLabel.Value}}</label>
										<input type="text" class="form-control" formControlName="merchantProductCode"/>
									</div>
									<div class="form-group">
										<label class="control-label">{{merchantFieldLabelMap.ItemIdLabel.Value}}</label>
										<input type="text" class="form-control" formControlName="merchantItemId"/>
									</div>
									<div class="form-group">
										<label class="control-label">{{merchantFieldLabelMap.MiscIdLabel.Value}}</label>
										<input type="text" class="form-control" formControlName="merchantMiscId"/>
									</div>
									<div class="form-group">
										<label class="control-label">{{merchantFieldLabelMap.RegionLabel.Value}}</label>
										<input type="text" class="form-control" formControlName="merchantRegion"/>
									</div>
									<div class="form-group">
										<label class="control-label">{{merchantFieldLabelMap.ServiceLevelLabel.Value}}</label>
										<input type="text" class="form-control" formControlName="merchantServiceLevel"/>
									</div>
									<div class="form-group">
										<label class="control-label">{{merchantFieldLabelMap.SitePublishDateLabel.Value}}</label>
										<shared-components-datepicker formControlName="merchantSitePublishDate" [min]="null"></shared-components-datepicker>
									</div>
								</div>
							</div>
						</form>
					</ng-container>
				</div>
			</app-tab>
			<app-tab title="Add Campaign Details" [disabled]="!customerForm.valid">
				<div *tabContent>
					<div class="row">
						<div class="col-md-12">
							<div class="mt-2 mb-4 small text-muted">
								Add key information about what this customer offers and where they operate
							</div>
							<form role="form" [formGroup]="campaignDetailsForm">
								<div class="col-4 form-group">
									<label class="form-label" for="campaignType">Campaign Type*</label>
									<div>
										<shared-components-customchoice
											id="campaignType"
											formControlName="isCampaignNational"
											[choiceFalse]="'Local'"
											[choiceTrue]="'National'">
										</shared-components-customchoice>
									</div>
								</div>
								<div class="col-8 form-group">
									<label class="form-label" for="productsOrServices">Products Or Services*</label>
									<ng-select
										id="productsOrServices"
										[addTag]="true"
										bindLabel="name"
										placeholder="Add products or services..."
										formControlName="productsOrServices"
										[multiple]="true">
									</ng-select>
								</div>
								<!-- Service Areas: only show for Local campaigns -->
								<div class="col-8 form-group"
										*ngIf="campaignDetailsForm.get('isCampaignNational')?.value === false">
									<label class="form-label" for="serviceArea">Service Areas*</label>
									<ng-select
										id="serviceArea"
										[items]="serviceAreas$ | async"
										[multiple]="true"
										[clearable]="true"
										[loading]="serviceAreaLoading"
										[minTermLength]="3"
										[typeahead]="serviceAreaInput$"
										bindLabel="Description"
										[compareWith]="compareAreas"
										formControlName="serviceAreas"
										placeholder="Service Areas"
										maxSelectedItems="20">
									</ng-select>
								</div>
								<div class="col-4 form-group">
									<label class="control-label">Anything we should avoid focusing on?</label>
									<textarea	class="form-control" formControlName="avoidFocusingOn" rows="5"></textarea>
								</div>
								<div class="d-flex justify-content-between">
									<button tabPrevious class="btn btn-secondary">
										<i class="fa fa-arrow-left me-1"></i>
										Back
									</button>
									<button tabNext class="btn btn-primary ms-auto" [disabled]="!campaignDetailsForm.valid">
										Next
									<i class="fa fa-arrow-right ms-1"></i>
								</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</app-tab>
			<app-tab title="Add Primary Contact" [disabled]="!campaignDetailsForm.valid">
				<div *tabContent>
					<div class="row">
						<div class="col-md-12">
							<div class="mt-2 mb-4 small text-muted">
								Enter contact details for the main point of contact we will reach out to for reporting,
								calls, updates, approvals, and other communications.
							</div>
							<form role="form" [formGroup]="primaryContactForm">
								<div class="row">
									<div class="form-group col-md-6">
										<label class="control-label">First Name*</label>
										<input type="text" class="form-control" formControlName="firstName" lpValidationMsg/>
									</div>
									<div class="form-group col-md-6">
										<label class="control-label">Last Name*</label>
										<input type="text" class="form-control" formControlName="lastName" lpValidationMsg/>
									</div>
									<div class="form-group col-md-6">
										<label class="control-label">Email*</label>
										<input type="email" class="form-control" formControlName="email" lpValidationMsg/>
									</div>
									<div class="form-group col-md-6">
										<label class="control-label">Phone*</label>
										<input type="text" class="form-control" formControlName="phone" lpValidationMsg/>
									</div>
									<ng-container *ngIf="partner.AllowsTextMessaging">
										<div class="form-group">
											<label class="control-label me-1">Can Receive Texts</label>
											<shared-components-customchoice formControlName="canReceiveTextMessages"></shared-components-customchoice>
            					<app-components-helptext [key]="'CustomerUser_CanReceiveTextMessages'"></app-components-helptext>
										</div>
									</ng-container>
								</div>
								<div class="d-flex justify-content-between">
									<button tabPrevious class="btn btn-secondary">
										<i class="fa fa-arrow-left me-1"></i>
										Back
									</button>
									<button tabNext class="btn btn-primary" [disabled]="!primaryContactForm.valid" (click)="updateEmailValidity()">
										Next
										<i class="fa fa-arrow-right ms-1"></i>
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</app-tab>
			<app-tab title="Add Additional Contacts" [disabled]="!customerForm.valid || !primaryContactForm.valid">
				<div *tabContent>
					<div class="row">
						<div class="col-md-12">
							<div class="mt-2 mb-4 small text-muted">
								Add any other people who should receive updates or reports. You can choose how they are included in emails.
							</div>
							<div>
								<app-components-sales-customer-users-form
									[primaryContactForm]="primaryContactForm"
									[(secondaryContactForms)]="secondaryContactForms"
									[allowTextMessages]="partner.AllowsTextMessaging"
									[countryAbbreviation]="countryAbbreviation()">
								</app-components-sales-customer-users-form>
							</div>
							<div class="d-flex justify-content-between">
								<button tabPrevious class="btn btn-secondary">
									<i class="fa fa-arrow-left me-1"></i>
									Back
								</button>
								<button class="btn btn-success" (click)="save()"
									[disabled]="!customerForm.valid || !primaryContactForm.valid || !secondaryContactForms.valid">
          				<i class="fa fa-store me-1"></i>
									Create account and go to order
								</button>
							</div>
						</div>
					</div>
				</div>
			</app-tab>
		</app-tab-panel>
  </div>
</div>